module.exports = __webpack_public_path__ + "img/whiteUparrow.2983b434.svg";